import { Box, Gap, Heading } from '@salecycle/ui-component-library';
import { useTranslation } from 'react-i18next';
import { useTemplateEditorState } from '../../../../context/UseTemplateEditorContext';
import { ValiationContainer, ValidationItemsList } from '../../../style';
import { ValidationCounters } from './components/ValidationCounters';
import { ValidationItem } from './components/ValidationItem';
import { TemplateSeverity } from 'sections/design/template-management/entities/templates';

/**
 * Sort validation results by severity: fail first, then warning, then pass
 * Note: When count is 0, the validation is effectively 'pass' regardless of the severity value
 */
const sortBySeverity = (a, b) => {
  const severityOrder = {
    [TemplateSeverity.FAIL]: 0,
    [TemplateSeverity.WARNING]: 1,
    [TemplateSeverity.PASS]: 2,
  };

  // Get effective severity: if count is 0, treat as 'pass' for sorting
  const getEffectiveSeverity = item => {
    return item.count > 0 ? item.severity : TemplateSeverity.PASS;
  };

  const aSeverity = getEffectiveSeverity(a);
  const bSeverity = getEffectiveSeverity(b);

  return severityOrder[aSeverity] - severityOrder[bSeverity];
};

export const TemplateValidationView = () => {
  const { t } = useTranslation(['designs', 'trackingLinks']);
  const { validationResults } = useTemplateEditorState();

  // Sort validation results: fail first, then warning, then pass
  const sortedValidationResults = [...validationResults].sort(sortBySeverity);

  return (
    <ValiationContainer data-testid="ValidationView">
      <Box horizontalPositioning="space-between">
        <Heading variation="h2">{t('trackingLinks:templateLevel.rightPanel.validation.heading')}</Heading>
        <ValidationCounters />
      </Box>
      <Gap bottom={30} />
      <ValidationItemsList>
        {sortedValidationResults.map(validationItem => {
          return <ValidationItem key={validationItem.rule} validationItem={validationItem} />;
        })}
      </ValidationItemsList>
    </ValiationContainer>
  );
};
